import { isTimeoutError } from '@ibk/shared-config';
import { ApiErrors } from '../enums';
export function handlePixError({ error, translate, errorMessages, defaultErrorKey }) {
    if (isTimeoutError(error)) {
        return errorMessages[ApiErrors.TIMEOUT_ERROR];
    }
    const apiError = error;
    const errorCode = apiError.details?.result?.code ?? apiError.details?.result?.error ?? defaultErrorKey;
    const errorMessage = errorMessages[errorCode] ?? errorMessages[defaultErrorKey];
    return translate(errorMessage);
}
